import React, { useState } from "react";
import { Collapse } from "reactstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
const FaqsAccordion = ({ faqDictionary, slugs, language }, context) => {
  const [open, setOpen] = useState("");
  const toggle = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div>
      {slugs?.map((slug, index) => (
        <div key={index}>
          <p
            className="h5 border-bottom p-2 mt-2 hv-pointer"
            onClick={() => toggle(index)}
          >
            {faqDictionary[language + "-" + slug]?.question}
            <span className="pull-right h6">
              {open !== index && <FaChevronDown />}
              {open === index && <FaChevronUp />}
            </span>
          </p>
          <Collapse isOpen={open === index} className="px-2">
            {/* Render HTML content */}
            <div
              dangerouslySetInnerHTML={{
                __html: faqDictionary[language + "-" + slug]?.answer,
              }}
            />
          </Collapse>
        </div>
      ))}
    </div>
  );
};

export default FaqsAccordion;
